import { useCallback, useMemo } from 'react'
import { useConfig } from '../../providers/config'
import { useStore } from '../../providers/store'
import { useTrackingsContext } from '../../providers/trackings'
import { useCookiesByGroupGet } from '../useCookiesByGroupGet'
import { useCookiesByStoreGet } from '../useCookiesByStoreGet'
import { useCountryShippingDefault } from '../useCountryShippingDefault'
import { useLocalStorageByGroupGet, useLocalStorageByGroupSet } from '../useLocalStorageByGroup'
import { ACTIONS } from './actions'

export const useTrackingsActions = () => {
	const config = useConfig()
	const trackings = useTrackingsContext()
	const getCookiesByStore = useCookiesByStoreGet()
	const getCookiesByGroup = useCookiesByGroupGet()
	const getLocalStorageByGroup = useLocalStorageByGroupGet()
	const setLocalStorageByGroup = useLocalStorageByGroupSet()
	const store = useStore()
	const {
		country: { code: defaultCountryCode },
	} = useCountryShippingDefault()

	const actionHandler = useCallback(
		async ({ type: actionType, args }) => {
			let almostOneExecuted = false
			for (const tracking of trackings) {
				const { ready, handler, id } = tracking
				const [firstArg, ...restArgs] = args
				if (ready) {
					try {
						await handler?.[actionType]?.(
							{
								...firstArg,
								config,
								getCookiesByStore,
								getCookiesByGroup,
								getLocalStorageByGroup,
								setLocalStorageByGroup,
								store,
								defaultShippingCountry: defaultCountryCode,
							},
							...restArgs
						)
						almostOneExecuted = true
					} catch (error) {
						console.error(`Tracking ${actionType} failed for ${id}`, '\n', error)
					}
				}
			}
			return almostOneExecuted
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[trackings, config, getCookiesByStore, getCookiesByGroup, getLocalStorageByGroup, setLocalStorageByGroup, store]
	)

	return useMemo(
		() => ACTIONS.reduce((acc, type) => ({ ...acc, [type]: (...args) => actionHandler({ type, args }) }), {}),
		[actionHandler]
	)
}
